import React from "react";
import AssessmentImg from "../../../assets/Assessment-1.png";
import AssessmentImg2 from "../../../assets/Assessment-2.png";
import AssessmentImg3 from "../../../assets/Assessment-3.png";
import AssessmentImg4 from "../../../assets/Assessment-4.png";
import { AssessmentCard } from "./AssessmentCard";
import { AssessmentArtical } from "./AssessmentArtical";
import "./MainContent.css";
import { Header } from "../Header-Assesment/Header";

export const MainContentAssessment = () => {
  return (
    <div className="mainarea-assessment">
      <div className="header-assessment">
        <Header
          title="Explore Your Inner Landscape"
          subtitle="Reflect on where you are today"
        />
      </div>
      <div className="main">
        <div className="assessment">
          <div className="blog-post-card">
            <AssessmentCard
              icon="🧠"
              title="  PEARLI™ Six domains of life scale"
              subtitle="The PEARLI™ Assessment is a quick, science-backed self-discovery tool that helps individuals gain insight into their well-being across six key life dimensions: Physical, Emotional, Acceptance (financial), Relationships, Loving-kindness, and Intellectual. Grounded in psychology, mindfulness, and emotional intelligence, it delivers a personalized report with actionable insights and a visual radar chart to guide growth."
              imgSrc={AssessmentImg2}
              link="/Disclaimer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
